/**
 * @generated SignedSource<<6a7c821b13d83380c2ec7db6a23014e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFAQ_itemSearch$data = {
  readonly faqHeader: string | null;
  readonly questionsAnswers: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"SharedFAQQuestion_question">;
  } | null> | null;
  readonly " $fragmentType": "SharedFAQ_itemSearch";
};
export type SharedFAQ_itemSearch$key = {
  readonly " $data"?: SharedFAQ_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFAQ_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFAQ_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faqHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionType",
      "kind": "LinkedField",
      "name": "questionsAnswers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedFAQQuestion_question"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "2e51bbb2abe29c34d6bf733cc6c970bb";

export default node;
